export default "__VITE_ASSET__nypUXtcF__"